'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ProjectDeleteSenderButton = require('containers/Project/ProjectDeleteSenderButton/ProjectDeleteSenderButton');

var _ProjectDeleteSenderButton2 = _interopRequireDefault(_ProjectDeleteSenderButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectSenderInfo.scss');

var ProjectSenderInfo = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectSenderInfo, _PureComponent);

  function ProjectSenderInfo() {
    (0, _classCallCheck3.default)(this, ProjectSenderInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectSenderInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectSenderInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectSenderInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          senderName = _props.senderName,
          senderEmail = _props.senderEmail,
          onDelete = _props.onDelete,
          projectId = _props.projectId;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.senderInfo, className) },
        _react2.default.createElement(
          'div',
          { className: styles.senderName },
          _react2.default.createElement(
            'div',
            null,
            t('Sender name'),
            ': ',
            senderName
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Sender email'),
            ': ',
            senderEmail
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.deleteSenderContainer },
          _react2.default.createElement(_ProjectDeleteSenderButton2.default, { onDelete: onDelete, projectId: projectId })
        )
      );
    }
  }]);
  return ProjectSenderInfo;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  onDelete: _propTypes2.default.func,
  projectId: _propTypes2.default.number,
  senderEmail: _propTypes2.default.string,
  senderName: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onDelete: _noop3.default
}, _temp);
exports.default = ProjectSenderInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectSenderInfo/ProjectSenderInfo.js
// module id = 2198
// module chunks = 1